// Helpers condivisi fra Orders admin & partner (filtri date + totale + metodo pagamento).

export const PAYMENT_METHOD_LABELS = {
  credito: "Credito Partner",
  paypal: "PayPal",
  bonifico: "Bonifico Bancario",
  bank: "Bonifico Bancario",
  carta: "Carta di Credito",
  fatturazione_mensile: "Fatturazione Mensile",
};

export const paymentMethodLabel = (method) => {
  if (!method) return "—";
  return PAYMENT_METHOD_LABELS[method] || method;
};

export const sumOrdersTotal = (orders) => (orders || []).reduce((s, o) => s + Number(o.total || 0), 0);
